import React from 'react';
import { PubNubConsumer } from 'pubnub-react';
import { connect } from 'react-redux';

import { dashboardOperations } from './duck';
import { dashboardActions } from './duck';
import DashboardComponent from './DashboardComponent';
import { userOperations } from '_data/modules/Users';

const mapStateToProps = ({ setupReducer, locationReducer, appReducer, dashboardDuckReducer, }) => ({
  locationConfig:
    setupReducer.setup_actions.meta.current_location.configuration,
  location: 
    locationReducer.locations.length > 1 ? locationReducer.location_data : locationReducer.locations[0],
  locationId: locationReducer.location_code,
  departments: appReducer.departments.data,
  myDepartments: appReducer.departments.myDepartments,
  totalRTOs: dashboardDuckReducer.requestTimeOffs.total,
});

const mapDispatchToProps = (dispatch) => ({
  handleShiftUpdate: (shift) =>
    dispatch(dashboardOperations.handleShiftUpdate(shift)),
  approvePendingShift: (shift, configId) =>
    dispatch(dashboardOperations.approvePendingShift(shift, configId)),
  getCostCenterData: (locationId) =>
    dispatch(dashboardOperations.getCostCenterData(locationId)),
  getRequestTimeOffs: (locationId, pageNo, numPerPage, sinceDate) =>
    dispatch(dashboardOperations.getRequestTimeOffs(locationId, pageNo, numPerPage, sinceDate)),
  getLocationEmployees: (locationId) =>
    dispatch(dashboardOperations.getLocationEmployees(locationId)),
  getLocationUsableSkills: (locationId) =>
    dispatch(dashboardOperations.getLocationUsableSkills(locationId)),
  getPendingUsers: (locationId) =>
    dispatch(userOperations.fetchPendingUsers(locationId)),
  getLocationInnerDepartments: (locationId) =>
    dispatch(dashboardOperations.getLocationInnerDepartments(locationId)),
  getLocationMyDepartments: (locationId) =>
    dispatch(dashboardOperations.getLocationMyDepartments(locationId)),
  
  getLocationEmployeesNew: (locationId) => {
    const params = {
    location_id: locationId,
    page: 1,
  };
    dispatch(dashboardOperations.fetchAllUsers(params));
  },

  resetTotalRTOs: () => {
    dispatch(dashboardActions.resetTotalRTOs(true));
  }
  
});

const DashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <PubNubConsumer>
      {(client) => {
        const { locationConfig,
                handleShiftUpdate,
                approvePendingShift, 
                location,
                locationId,
                getCostCenterData, 
                getRequestTimeOffs,
                getLocationEmployees,
                getLocationEmployeesNew,
                getLocationUsableSkills,
                getPendingUsers,
                getLocationInnerDepartments,
                departments,
                getLocationMyDepartments,
                myDepartments,
                totalRTOs,
                resetTotalRTOs,
                 } = props;

        return (
          <DashboardComponent
            pubnub={client}
            locationConfig={locationConfig}
            handleShiftUpdate={handleShiftUpdate}
            approvePendingShift={approvePendingShift}
            location={location}
            locationId={locationId}
            getCostCenterData={getCostCenterData}
            getRequestTimeOffs={getRequestTimeOffs}
            getLocationEmployees={getLocationEmployees}
            getLocationEmployeesNew={getLocationEmployeesNew}
            getLocationUsableSkills={getLocationUsableSkills}
            getPendingUsers={getPendingUsers}
            getLocationInnerDepartments={getLocationInnerDepartments}
            departments={departments}
            getLocationMyDepartments={getLocationMyDepartments}
            myDepartments={myDepartments}
            totalRTOs={totalRTOs}
            resetTotalRTOs={resetTotalRTOs}
          />
        );
      }}
    </PubNubConsumer>
  );
});

export default DashboardContainer;
